const CreditAssessmentStatus = {
  IN_PROGRESS: 'IN_PROGRESS',
  APPROVED: 'APPROVED',
  INCORRECT_ID: 'INCORRECT_ID',
  DECLINED: 'DECLINED',
  ERROR: 'ERROR'
};

export default CreditAssessmentStatus;



/** WEBPACK FOOTER **
 ** ./src/model/CreditAssessmentStatus.js
 **/